// Central taxonomy for resource types and topics.
//
// Ingestion workflow:
//   1. Add new values here as you encounter them during ingestion.
//   2. After a batch, evaluate: remove duplicates, combine overlapping tags, rename labels.
//   3. Update resource frontmatter values to match the canonical list.
//
// value  — slug used in frontmatter YAML and URL query params (kebab-case, stable)
// label  — display string shown in UI (can be changed without re-processing markdown)

// Lookup helper: returns the display label for a tag value, or falls back to
// humanising the value string if it hasn't been registered yet.
export function getLabel(list, value) {
  return list.find(t => t.value === value)?.label
    ?? value.replace(/-/g, ' ')
}

// Note: `value` slugs are stable identifiers used in frontmatter and URL query
// params, so several labels below have been renamed without changing the slug
// (e.g. slug 'education' now displays as 'Inclusive education'). A slug is only
// a machine key — a label/slug divergence is harmless and avoids migrating
// existing resource frontmatter and breaking shared filter URLs.
export const TOPICS = [
  { value: 'assessment-and-diagnosis',      label: 'Assessment and diagnosis' },
  { value: 'career-and-employment',         label: 'Careers and employment' },
  { value: 'community-connection',          label: 'Community engagement' },
  { value: 'education',                     label: 'Inclusive education' },
  { value: 'health-and-wellbeing',           label: 'Health and wellbeing' },
  { value: 'inclusive-research-practices',  label: 'Inclusive research practices' },
  { value: 'support-needs',                 label: 'Strengths and support needs' },
  { value: 'informing-policy',              label: 'Informing policy' },
]

// Curated "Featured" sort order for /resources. These slugs are pinned to the
// top of the listing in this exact order; every other resource follows by
// newest publishedOn. This is the default sort on the Resource Centre.
export const FEATURED_ORDER = [
  'inclusioned',
  'self-advocacy-at-work',
  'bp-participatory-research-easy-read',
  'bp-strengths-supports-tool',
  'community-forum-guidance',
]

export const RESOURCE_TYPES = [
  { value: 'guidelines-frameworks', label: 'Guidelines and frameworks' },
  { value: 'elearning',             label: 'eLearning' },
  { value: 'poster',                label: 'Posters' },
  { value: 'publications',          label: 'Publications' },
  { value: 'websites',              label: 'Websites' },
  { value: 'easy-read',             label: 'Easy Reads' },
]
